import { WorkflowWebhookModel } from '@models/workflow-webhook.model';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { WorkflowWebhookActions } from './workflow-webhooks.action-type';

export interface WorkflowWebhookState extends EntityState<WorkflowWebhookModel.WebhookEndpointMongoDocument> {
  isLoading: boolean;
  isSaving: boolean;
  createdId: string;
}

export const adapter: EntityAdapter<WorkflowWebhookModel.WebhookEndpointMongoDocument> =
  createEntityAdapter<WorkflowWebhookModel.WebhookEndpointMongoDocument>({
    selectId: (webhook: WorkflowWebhookModel.WebhookEndpointMongoDocument) =>
      webhook._id,
  });

export const initialState: WorkflowWebhookState = adapter.getInitialState({
  isLoading: false,
  isSaving: false,
  createdId: null,
});

export const { selectAll, selectEntities, selectIds, selectTotal } =
  adapter.getSelectors();

export const workflowWebhookStateReducer = createReducer(
  initialState,
  on(
    WorkflowWebhookActions.getWorkflowWebhooksSuccess,
    (state, { webhooks }) => {
      return adapter.addMany(webhooks, {
        ...state,
      });
    },
  ),
  on(WorkflowWebhookActions.createWorkflowWebhook, (state) => {
    return {
      ...state,
      createdId: null,
    };
  }),
  on(
    WorkflowWebhookActions.createWorkflowWebhookSuccess,
    (state, { webhook }) => {
      return adapter.addOne(webhook, {
        ...state,
        createdId: webhook._id,
      });
    },
  ),
  on(WorkflowWebhookActions.deleteWorkflowWebhookSuccess, (state, { id }) => {
    return adapter.removeOne(id, {
      ...state,
    });
  }),
  on(
    WorkflowWebhookActions.editWorkflowWebhookSuccess,
    (state, { webhook }) => {
      return adapter.updateOne(
        {
          id: webhook._id,
          changes: { ...webhook },
        },
        {
          ...state,
        },
      );
    },
  ),
  on(WorkflowWebhookActions.setIsLoading, (state, { isLoading }) => {
    return {
      ...state,
      isLoading: isLoading,
    };
  }),
  on(WorkflowWebhookActions.setIsSaving, (state, { isSaving }) => {
    return {
      ...state,
      isSaving: isSaving,
    };
  }),
  on(WorkflowWebhookActions.resetState, () => {
    return adapter.removeAll({
      ...initialState,
    });
  }),
  on(WorkflowWebhookActions.resetEntities, (state) => {
    return adapter.removeAll({
      ...state,
    });
  }),
);
